import axiosApiInstance from '../request';

const postContactSupportService = async (payload: any) => {
  const response: { [k: string]: any } = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    const res = await axiosApiInstance.post(`/support-email/`, payload, {
      headers
    } as any);
    if (res && res.status === 201) {
      response.data = res?.data;
      response.statusCode = res?.status;
    }
  } catch (error: any) {
    response.statusCode = error?.data?.status;
  }
  return response;
};

const postConsultUsService = async (payload: any) => {
  const response: { [k: string]: any } = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    const res = await axiosApiInstance.post(`/inquiry/`, payload, {
      headers
    } as any);
    if (res && res.status === 201) {
      response.data = res?.data;
      response.statusCode = res?.status;
    } else {
      response.statusCode = res?.status;
    }
  } catch (error: any) {
    response.statusCode = error?.status;
  }
  return response;
};
const postNewsLetterService = async (payload: any) => {
  const response: { [k: string]: any } = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    const res = await axiosApiInstance.post(`/newsletter/`, payload, {
      headers
    } as any);
    if (res) {
      response.data = res?.data;
      response.statusCode = res?.status;
    }
  } catch (error: any) {
    response.statusCode = error?.status;
  }
  return response;
};

const postDisputeService = async (payload: any) => {
  const response: { [k: string]: any } = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    const res = await axiosApiInstance.post(`/raise-job-dispute/`, payload, {
      headers
    } as any);
    if (res) {
      response.data = res?.data;
      response.statusCode = res?.status;
    }
  } catch (error: any) {
    response.statusCode = error?.data?.status;
  }
  return response;
};

export {
  postContactSupportService,
  postDisputeService,
  postConsultUsService,
  postNewsLetterService
};
